import React from 'react';
import { FormattedMessage } from 'react-intl';

import { UI_DATE_FORMAT_PLACEHOLDER } from '../../../../../constants';
import { TextField } from '../../../../common/text-field';
import { IChangeBirthdayFieldViewProps } from './change-birthday-field.models';

const noop = (): void => {};

export const ChangeBirthdayField = ({
  dateOfBirth,
  onBirthdayChange,
}: IChangeBirthdayFieldViewProps): JSX.Element => (
  <TextField
    value={dateOfBirth}
    onChange={noop}
    data-testid="change-birthday-field"
    fullWidth
    placeholder={UI_DATE_FORMAT_PLACEHOLDER}
    InputProps={{
      readOnly: true,
    }}
    label={(
      <FormattedMessage
        id="profile.dateOfBirthTextField.label"
      />
    )}
    actionProps={{
      'data-testid': 'change-date-button',
      onClick: onBirthdayChange,
      children: <FormattedMessage id="common.change"/>,
    }}
  />
);
